module.exports = "img/flags/AF.e369451.png";